import Vue from 'vue'
Vue.component("me-tree-add", {
    props: {
        deep: {
            type: Number,
            default: 0
        },
        list: {//列表内容
            type: Object,
            default: () => ({})
        },
        labelw: {//列表内容
            type: Array,
            default: () => ([])
        },
        editl: {
            type: Array,
            default: () => ([])
        },
        pagec: {//列表内容
            type: Function
        },
        treeitem: {//列表内容
            type: Function
        },
    },
    data() {
        return {
            loads: {
                type: false,
                index: 0
            },
            open: {

            }
        }
    },
    watch:{        
        list:{
            handler(newVal,oldVal) {
              },
              deep: true
        },
        deep:{
            handler(newv, old) {
            },
            deep:true
        }
    },
    mounted() {
    },
    // <el-tooltip placement="topLeft" :title="item[labelw[0].prop]">
    //     {{item[labelw[0].prop] || '-'}}
    // </el-tooltip>el-icon-arrow-down
    template: `
        <div>
            <div class='treeitem'  :class="classObject(deep)" v-for="(item,index) in list.list" :key="index">
               <div :style="{transform:'translateX(-'+(deep+1)*20+'px)',  width: 'calc(100% + '+(deep+1)*20 +'px)'}" class='lines'></div>
                <div class='flex flex-ac flex-jc-sa rowitem'> 
                    <div class='flex1 title-ti flex flex-ac'  @click.stop='treeitem({item,list,loads,index,open,deep})'  style='padding-left:0' >
                        <div class='icons-down-box'><i :class='item.openState?"el-icon-arrow-down":"el-icon-arrow-right"' v-if='!item.leaf'></i></div>                                                
                        <div v-if="item.status=='discard'" class="titleMerged">
                            <div class='titleMergedChildren'>
                                    {{item[labelw[0].prop] || '-'}}
                            </div>    
                            <div class="titleMergediconLeft"></div><div class="titleMergedicon"></div><div class="titleMergediconRight"></div>
                            <span class="titleMergedRight">合并至</span>
                                {{item[labelw[0].props] || '-'}}
                        </div>
						<div v-else class='title-box'>                            
                            {{item[labelw[0].prop] || '-'}}
                        </div> 
                    </div>
					<div v-if='labelw.length>1'  class='title-ti'  v-for="(tt,tin) in [...labelw.slice(1)]" :key="tin">
						<div >{{item[tt.prop] || '-'}}</div> 
					</div>
                    <div v-if='item.status=="draft"'  class='title-ti'>
                        <span class='titleStatus'>待审核</span>    
					</div>
                    <div v-else>
                        <div v-if='editl.length >= 1 && item.leaf'  class='title-ti'>
                            <el-button style='padding:4px 6px' type="text" @click.stop="tt.click(item)" v-for="(tt,tin) in editl" key="tin" size="mini" v-if="editl[0].name1!==''">{{editl[0].name1}}</el-button>
                        </div>
                        <div v-else-if="item.leaf"  class='title-ti'>
                            <el-button style='padding:4px 6px' type="text" @click.stop="tt.click(item)" v-for="(tt,tin) in editl" key="tin" size="mini" v-if="editl[0].name2!==''">{{editl[0].name2}}</el-button>
                        </div>
                    </div>                      
                </div>
                <me-tree-add :row-key='item[list.rowKey]' :pagec='pagec' :editl='editl' :labelw='labelw' v-if='open[index]' :treeitem='treeitem' :list='item' :deep='(deep+1)'></me-tree-add>
            </div>
            <div  v-if='list.total && list.total>10 &&  list.list && list.list.length > 0'>            
               <div :style="{transform:'translateX(-'+(deep)*20+'px)',  width: 'calc(100% + '+20 +'px)'}" class='lines'></div>
                <el-pagination
                    @current-change='(p)=>(pagec({p,list}))'
                    :page-size='list.page'
					@size-change="(ps)=>(pagec({p:1,list,ps}))"					
                    layout="prev, pager, next" 
                    :total="list.total">
                </el-pagination>
            </div>
        </div>
    `,
    methods: {
        classObject: function (deep) {
            if (deep > 5) deep = 5
            return {
                ["temp-lv" + deep]: true,
            }
        },
        aaclick(item) {
            let cohortConditionDto = {
                // value:'',
                // value2:''
            }
            let items = { ...item, cohortConditionDto: cohortConditionDto }
            this.$store.commit('treeListObj', items);
        }
    }

});


Vue.component("box-tree-add", {
    props: {
        deep: {
            type: Number,
            default: -1
        },
        proplist: {//列表内容
            type: Object,
            default: () => ({})
        },
        editl: {
            type: Array,
            default: () => ([])
        },
        pagec: {//列表内容
            type: Function
        },
        treeitem: {//列表内容
            type: Function
        },
        ld: {
            type: Boolean,
            default: false
        },
    },
    mounted() {
    },

    template: `
        <div>
            
            <me-tree-add :pagec='pagec' v-loading='ld' :treeitem='treeitem' :editl='editl' :labelw='proplist.labelw' :list='proplist.col' :deep='(deep+1)'></me-tree-add>
        </div>
    `,
    methods: {

    }
});